module.exports = __webpack_public_path__ + "media/metronic/_theme/media/products/product12-ed1294125d59248300885c7405d69c68.jpg";